"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMPTY_ARR = void 0;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
exports.EMPTY_ARR = [];
// TODO replace EMPTY_OBJECT declarations
// export const EMPTY_OBJECT: any = {};
// TODO move NOOP here?
